module.exports = __webpack_public_path__ + "static/media/sportactive.4a3e2ea2.png";